import * as React from 'react';
export function useViewModel({ onStarClick, rating: providedRating, }) {
    const [hoverStarRating, setHoverStarRating] = React.useState(undefined);
    const [committedStarRating, setCommittedStarRating] = React.useState(providedRating);
    React.useEffect(() => {
        setCommittedStarRating(providedRating);
    }, [providedRating]);
    const chooseCommittedStarRating = React.useCallback((starRating) => {
        setCommittedStarRating(starRating);
        onStarClick && onStarClick(starRating);
    }, [onStarClick]);
    return {
        chooseCommittedStarRating,
        committedStarRating,
        hoverStarRating,
        setHoverStarRating,
    };
}
//# sourceMappingURL=useViewModel.js.map